import { Pipe, PipeTransform } from '@angular/core';
import { PackagingFormat } from '@rds/rds-packaging-ts';

@Pipe({
  name: 'rdsJoinFormats',
})
export class RdsJoinFormatsPipe implements PipeTransform {
  transform(value: PackagingFormat[]): string {
    return value.map((v) => v.name).join(', ');
  }
}
